import axios from "axios";
import Qs from "qs";
import {TokenUtil, SysUtil} from "@/utils/comm";
import {utils} from '@/utils/utils'
const GET_OPINION_API = '/processApi/gzl/bpm/instance/getOpinion';

axios.defaults.timeout = 30000;

const newWhiteList = ['/portalApi/newListManage/getNewList', '/portalApi/newListManage/getNewInfo']
//请求拦截,
axios.interceptors.request.use(async config => {
    config.headers['appid'] = '12987573c017430fb543e9ae7943293d'
    if (config.url.indexOf('/authApi/oauth/token') >= 0 && config.data.grant_type == 'refresh_token') {
        console.info("config.params.grant_type == 'refresh_token'");
    } else {
        // config.headers['X-Access-Token'] = await TokenUtil.getAccessToken();
        let token = await TokenUtil.getAccessToken();
        if(token) config.headers['X-Access-Token'] = await TokenUtil.getAccessToken();
        // if(getStore('relCookie')){
        //     config.headers['relCookie'] =getStore('relCookie')
        // }
        // 新闻资讯
        if(newWhiteList.includes(config.url)) {
          delete config.headers['X-Access-Token']
        }
    }
    if (config.intercept) {
        return config;
    }

    if ("true" === process.env.VUE_APP_SM_ENABLE) {
			// sm2 加密
			if (config.url.indexOf('/authApi') >= 0 || config.url.indexOf('/uploadApi') >= 0) {
				config.url = config.url.replace('/api', '')
				let k = 0
				for (let i = 0; i < requestWhiteList.length; i++) {
					if (config.url.indexOf(requestWhiteList[i]) >= 0) {
						if (config.method == 'post') {
								config.data = Qs.stringify(config.data)
						}
						++k
						break
					}
				}
				// if (k === 0) {
				// 	config = handleSM2(config)
				// }
			}
		} else {
      //不需要加密（白名单）
      if (config.url.indexOf('/authApi') >= 0) {
          if (config.method == 'post') {
              config.data = Qs.stringify(config.data)
          }
          return config
      }
      if (config.url.indexOf('/uploadApi') >= 0) {
          if (config.method == 'post') {
              config.data = Qs.stringify(config.data)
          }
          return config
      }
    }
    if (config.url.indexOf('/xmzxApi') >= 0 || config.url.indexOf('/portalApi') >=0  || config.url.indexOf('/uploadApi') >= 0 ) {
        if (config.url.indexOf('/uploadApi/onlinePreview') >= 0) {
            return config
        }
        //post加密
        if (config.method == 'post') {
            //整体加密(白名单)
            if (['itemsApi'].some(urlText => config.url.indexOf(urlText) >= 0)) {
                config.headers['Content-Type'] = 'application/json'
                config.data = JSON.stringify(config.data)
            } else {
                config.data = Qs.stringify(config.data)
            }
        //get加密
        } else if (config.method == 'get') {
        }
        return config;
    }

    return config;
});

//响应拦截
axios.interceptors.response.use(res => {
        if (res.config.url.indexOf('/xmzxApi') >= 0 || res.config.url.indexOf('/portalApi') >= 0) {
          // 返回值不解密接口白名单
          let interfaceWhiteList = ['/xmzxApi/pdfGen/getTemplatePdf']
          // 志愿者申请表
          // if(!interfaceWhiteList.includes(res.config.url)) {
          //   res.data = doDecrypt(res.data)
          // }
        }
        if (res.status === 200 && (res.data.code === 100 || res.data.code == 200 || res.data.code === 0 || !!res.data.access_token)) {
            // 拦截返回结果，处理数据结构
            if(res.config.url.indexOf(GET_OPINION_API) >= 0){
                res.data.data = reverseArray(res.data.data)
            }
            return Promise.resolve(res);
        // } else if(res.data.code === '401'){
        //     onError(res.data);
        //     SysUtil.clearSysState();
        //     window.sessionStorage.clear();
        } else {
            // onError(res.data);
            return Promise.resolve(res);
        }
    }, error => {
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data);
        } else {
            onError(error);
            return Promise.reject(error);
        }
    }
);

function reverseArray (arr){
    if (arr == null || arr == '' || arr.length === 0) return arr;
    if (arr instanceof Array) {
        arr = arr.reverse();
    }
    return arr;
}

//get请求
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: params}, {headers: {'content-type': 'application/json'}})
            .then(res => {
                if (res) resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

//post请求
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {headers: {'content-type': 'application/json'}})
            .then(res => {
                if (res) resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

//自定义请求头get请求
export function ownGet(url, params = {}, flag={}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: params, headers: {'content-type': 'application/x-www-form-urlencoded', ...flag}})
            .then(res => {
                if (res) resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

//post请求
export function ownPost(url, params = {}) {
    const temParams = new URLSearchParams();
    for(let item in params){
        temParams.append(item, params[item]);
    }
    return new Promise((resolve, reject) => {
        axios
            .post(url, temParams, {headers: {'content-type': 'application/x-www-form-urlencoded'}})
            .then(res => {
                if (res) resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

// loginPost请求
export function loginPost(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {headers: {'content-type': 'application/x-www-form-urlencoded'}})
            .then(res => {
                if (res) resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

//自定义接口请求
export const sendReq = async (option) => {
    const defaultOption = {
      method: "GET",
      intercept: true
    }
    const res = await axios.request(
        Object.assign(defaultOption, option)
    );
    return res.data;
}

export const sendPostReq = async (url,params) => {
    const defaultOption = {
      method: "POST",
      intercept: true,
      url: url,
      data: JSON.stringify(params),
      headers: {"content-type": 'application/json'}
    }
    const res = await axios.request(defaultOption);
    return res.data;
}



let showError = throttle((msg, cb) => {
    if (typeof cb === "function") cb();
});

//接口报错处理
function onError(res) {
    if (res.code) {
        switch (res.code) {
            //用户登录过期
            case 401:
                showError("用户登录过期，请重新登录！", () => {
                    // SysUtil.clearSysState();
                });
                break;
        }
    }
}

function throttle(cb) {
    var timer = null;
    return function () {
        var context = this,
            args = arguments;
        if (!timer) {
            cb.apply(context, args);
            timer = setTimeout(() => {
                clearTimeout(timer);
                timer = null;
            }, 2000);
        }
    };
}

/**
 * Http Util 基础服务
 * 为保持低代码原来接口请求方式添加
 */
const proxyName = window.proxyName = `/processApi`;
export const HttpUtil = {
    async get(url, params = {}) {
        return await sendReq({ url: `${proxyName}${url}`, params: params })
    },
    async post(url, data = {}) {
        return await HttpUtil.postForm(url, data, 'application/json')
    },
    /**
     * form-data格式化
     * @param {*} url 请求连接
     * @param {*} data 请求数据
     * @param {
     *  isEncrypt 是否加密
     *  mode 加密方式 整体加密(encryptText)/参数加密(encryptParam)
     * } encrypt 请求加密方式
     * @param {*} contentType 请求格式
     * @returns
     */
    async postForm(url, data = {}, contentType) {
        // if (!contentType) {
        //     data = Qs.stringify(data)
        // } else {
        //     data = JSON.stringify(data)
        // }
        const temParams = new URLSearchParams();
        for(let item in data){
            temParams.append(item, data[item]);
        }
        return await sendReq({
            method: 'POST',
            url: `${proxyName}${url}`,
            data: temParams,
            headers: {
                "content-type": contentType || "application/x-www-form-urlencoded",
            }
        })
    }
}

export default {
    // 全局安装时候
    install (Vue) {
        Vue.abHttpUtil = HttpUtil;
        Vue.prototype.abHttpUtil = HttpUtil;
    }
}
